import { render } from "./OrderInvoiceList.vue?vue&type=template&id=16005686&scoped=true"
import script from "./OrderInvoiceList.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceList.vue?vue&type=script&lang=js"

import "./OrderInvoiceList.vue?vue&type=style&index=0&id=16005686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16005686"]])

export default __exports__